module.exports = __webpack_public_path__ + "img/Monte_Kope_51.ac896342.jpg";